import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { apiFetch, throwIfNotOk } from './services/apiClient';
import './GreetingPage.css';

const GreetingPage = () => {
    const { jobId } = useParams();
    const navigate = useNavigate();
    const [greeting, setGreeting] = useState(null);
    const [jobTitle, setJobTitle] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [formSettings, setFormSettings] = useState(null);

    useEffect(() => {
        fetchGreeting();
        fetchFormSettings();
    }, [jobId]);

    const fetchFormSettings = async () => {
        try {
            const response = await apiFetch(`/api/jobs/${jobId}/form-settings`);
            if (response.ok) {
                const data = await response.json();
                setFormSettings(data);
            }
        } catch (error) {
            console.error('Error fetching form settings:', error);
        }
    };

    const fetchGreeting = async () => {
        try {
            const response = await apiFetch(`/api/jobs/${jobId}/greeting`);
            await throwIfNotOk(response);
            const data = await response.json();
            setGreeting(data.greeting_message);
            setJobTitle(data.job_title);
        } catch (error) {
            console.error('Error fetching greeting:', error);
            setError(error.message || 'Failed to load application page. Please try again later.');
        } finally {
            setLoading(false);
        }
    };

    const handleContinue = () => {
        // Navigate to application form
        navigate(`/apply/${jobId}`);
    };

    if (loading) {
        return (
            <div className="greeting-page">
                <div className="greeting-container">
                    <div className="loading-spinner">Loading...</div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="greeting-page">
                <div className="greeting-container">
                    <div className="error-message">{error}</div>
                </div>
            </div>
        );
    }

    const activeSettings = formSettings || {
        form_background_color: '#f5f5f5',
        form_text_color: '#333333',
        form_primary_color: '#667eea'
    };

    // Apply main app theme background (dark with radial gradients) if using default color
    const backgroundStyle = activeSettings.form_background_color === '#f5f5f5' || !activeSettings.form_background_color
        ? { 
            backgroundColor: '#0c001f',
            backgroundImage: `
                radial-gradient(at 20% 20%, hsla(28,100%,74%,0.15) 0px, transparent 50%),
                radial-gradient(at 80% 20%, hsla(217,100%,50%,0.15) 0px, transparent 50%),
                radial-gradient(at 80% 80%, hsla(339,100%,50%,0.15) 0px, transparent 50%),
                radial-gradient(at 20% 80%, hsla(140,100%,50%,0.15) 0px, transparent 50%)
            `
          }
        : { backgroundColor: activeSettings.form_background_color };

    return (
        <div className="greeting-page" style={backgroundStyle}>
            <div className="greeting-container">
                <div className="greeting-header">
                    <h1>Welcome!</h1>
                    {jobTitle && <h2>{jobTitle}</h2>}
                </div>
                
                <div className="greeting-message">
                    {greeting ? (
                        <div className="message-content">
                            {greeting.split('\n').map((line, index) => (
                                <p key={index}>{line || <br />}</p>
                            ))}
                        </div>
                    ) : (
                        <p>Thank you for your interest in this position!</p>
                    )}
                </div>
                
                <div className="greeting-actions">
                    <button 
                        onClick={handleContinue}
                        className="continue-button"
                        style={{ backgroundColor: activeSettings.form_primary_color || '#667eea' }}
                    >
                        Continue to Application →
                    </button>
                </div>
            </div>
        </div>
    );
};

export default GreetingPage;
